export const none = {
  boxShadow: 'none',
}

export const small = {
  boxShadow:
    '0 0 4px 0 rgba(0, 0, 0, 0.14), 0 2px 2px 0 rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.20)',
}

export const medium = {
  boxShadow: '0 2px 16px 0 rgba(0,0,0,0.15)',
}

export const large = {
  boxShadow: '16px 16px 24px 0 rgba(0,0,0,0.1)',
}
